
const countdownTextsEng = {
    preText: '20% OFF ALL SEATS, ALL FLIGHTS!. Book Now! You have',
    subText: 'Book Now!',
    days: 'days',
    hours: 'hours',
    minutes: 'mins',
    seconds: 'secs'
}

const countdownTextsId = {
    preText: 'DISKON 20% UNTUK SEMUA KURSI, SEMUA PENERBANGAN!. Pesan sekarang! Anda memiliki waktu ',
    subText: 'lagi!',
    days: 'hari',
    hours: 'jam',
    minutes: 'menit',
    seconds: 'detik'
}

const countdownTextsTh = {
    preText: 'ตั๋วเครื่องบินลด 20% จองภายใน xx ชม. xx นาที xx วินาที',
    subText: 'เท่านั้น จองเลย!',
    days: 'วัน',
    hours: 'ชั่วโมง',
    minutes: 'นาที',
    seconds: 'วินาที'
}

const countdownTextsVn = {
    preText: 'Đừng bỏ lỡ cơ hội bay giá rẻ. Bạn chỉ còn',
    subText: 'Đặt ngay!',
    days: 'ngày',
    hours: 'giờ',
    minutes: 'phút',
    seconds: 'giây'
}

const countdownTextsPh = {
    preText: 'Don\'t Miss Your Chance to get 20% OFF. You have ',
    subText: 'Mag-book na!',
    days: 'araw',
    hours: 'oras',
    minutes: 'minuto',
    seconds: 'segundo'
}

const countdownTextsJp = {
    preText: 'お得な航空券を逃さないでください。残り',
    subText: 'で終了。今すぐ予約！',
    days: '日',
    hours: '時間',
    minutes: '分',
    seconds: '秒'
}

const countdownTextsCn = {
    preText: '不要错过廉价机票的机会。剩余时间',
    subText: '立即预订！',
    days: '天',
    hours: '小时',
    minutes: '分钟',
    seconds: '秒'
}

const countdownTextsKr = {
    preText: '저렴한 항공권을 놓치지 마세요. 남은 시간',
    subText: '지금 예약하세요!',
    days: '일',
    hours: '시간',
    minutes: '분',
    seconds: '초'
}

const countdownTextsKmKh = {
    preText: 'កក់ឥឡូវនេះមិនបានចុះបញ្ជីទេ! អ្នកមានពេលវេលា',
    subText: 'កក់ឥឡូវនេះ!',
    days: 'ថ្ងៃ',
    hours: 'ម៉ោង',
    minutes: 'នាទី',
    seconds: 'វិនាទី'
}

const countdownTextsRu = {
    preText: 'Не упустите возможность купить дешевые авиабилеты. Осталось всего',
    subText: 'Забронируйте сейчас!',
    days: 'дней',
    hours: 'часов',
    minutes: 'минут',
    seconds: 'секунд'
}

const countdownTextsTr = {
    preText: 'Ucuz uçak bileti fırsatını kaçırmayın. Sadece',
    subText: 'Hemen rezervasyon yapın!',
    days: 'gün',
    hours: 'saat',
    minutes: 'dakika',
    seconds: 'saniye'
}

export const countDownTextsObj = {
    'en-gb': countdownTextsEng,
    'id-id': countdownTextsId,
    'th-th': countdownTextsTh,
    'vi-vn': countdownTextsVn,
    'ph-ph': countdownTextsPh,
    'ja-jp': countdownTextsJp,
    'zh-cn': countdownTextsCn,
    'zh-tw': countdownTextsCn,
    'zh-hk': countdownTextsCn,
    'ko-kr': countdownTextsKr,
    'km-kh': countdownTextsKmKh,
    'ru-ru': countdownTextsRu,
    'tr-tr': countdownTextsTr
}

export default countDownTextsObj;